<template>
    <div class="gap-xs flex items-center justify-end" @click.stop>
        <button
            v-for="(action, index) in actions"
            :key="index"
            :class="getButtonClass(action.variant)"
            :disabled="action.disabled"
            @click="action.onClick"
        >
            <i v-if="action.icon" :class="action.icon" />
            <span v-if="action.label">{{ action.label }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
import type { ActionButtonsCellProps } from '../types'
import { buttonVariants } from '@/components/ui/button'

defineProps<ActionButtonsCellProps>()

// ITDEVELOP-2723: colours come from ui/Button's token variants instead of the
// frozen legacy btn-* utilities. The cell keeps its own <button> elements (the
// action API passes disabled/onClick straight through), so we consume the cva
// class strings rather than the component. `secondary` is the token contract's
// light secondary, not the legacy charcoal — decided on the ticket, 2026-07-28.
// `link` still uses btn-link: that utility is outside this ticket's scope.
function getButtonClass(variant?: string): string {
    const baseClasses = 'flex'

    switch (variant) {
        case 'primary':
            return `${baseClasses} ${buttonVariants({ variant: 'default' })}`
        case 'secondary':
            return `${baseClasses} ${buttonVariants({ variant: 'secondary' })}`
        case 'danger':
            return `${baseClasses} ${buttonVariants({ variant: 'destructive' })}`
        case 'link':
        default:
            return `${baseClasses} btn-link`
    }
}
</script>
